import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../shared';
import { SystemService } from 'app/shared/system.service';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  constructor(private auth: AuthService,
    public system: SystemService,
    @Optional() private dialogRef?: MatDialogRef<LoginComponent>) {}

  error: string;
  message: string;
  passwordVisible = false;
  showLogin$ = this.auth.isAuthenticated.pipe(
    startWith(this.auth.isAuthenticated.value),
    map(v => v !== undefined)
  );

  login(info: { userName: string; password: string }) {
    this.error = '';
    this.auth
      .login(info)
      .subscribe(
        _ => this.closeForm(true),
        error => this.handleError(error)
      );
  }

  closeForm(success = false) {
    if (this.dialogRef) {
      this.dialogRef.close(success);
    }
  }

  private handleError(errorInfo: any) {
    this.error = (errorInfo && errorInfo.error && errorInfo.error.error_type) || 'unknown';
  }
}
